import {api} from "./api";
import {checkIfValid} from "./mate/mate-utils";

export const waitForResultPromise = <T>(getDataFn: () => T) =>
  // resolve() unwraps a promise result, so callers see the settled value
  new Promise<Awaited<T>>((resolve) => waitForResult(getDataFn, (r) => resolve(r as Awaited<T>)));

export const waitForResult = <T>(
  getDataFn: () => T,
  resultFn: (result: T) => void
): undefined | (() => void) => {
  const {isLoaded, result} = checkIfValid(getDataFn, api);
  if (isLoaded) {
    resultFn(result);
  } else {
    const unsub = api.registerOnChangeListener(() => {
      const testAgain = checkIfValid(getDataFn, api);
      if (testAgain.isLoaded) {
        unsub();
        resultFn(testAgain.result);
      }
    });
    return unsub;
  }
};
